<template>
    <div class="wrong-page">
        <!-- ---------- 头部 ---------- -->
        <header class="wp-hero">
            <div class="hero-top">
                <span class="hero-back" @click="goBack">‹</span>
                <span class="hero-title">错题本</span>
                <span class="hero-back ghost"></span>
            </div>

            <div class="hero-nums">
                <div class="hn">
                    <p class="hn-label">错题总数</p>
                    <p class="hn-num">{{ stat.total }}<em>题</em></p>
                </div>
                <div class="hn">
                    <p class="hn-label">未掌握</p>
                    <p class="hn-num"><b class="warn">{{ stat.unmastered }}</b><em>题</em></p>
                </div>
                <div class="hn">
                    <p class="hn-label">掌握率</p>
                    <p class="hn-num">{{ stat.rate }}<em>%</em></p>
                </div>
            </div>

            <div class="hero-bar"><i :style="{ width: stat.rate + '%' }"></i></div>
            <p class="hero-tip">先把错 2 次以上的题过一遍，性价比最高</p>
        </header>

        <main class="wp-body">
            <!-- ---------- 科目筛选 ---------- -->
            <div class="chips">
                <span class="chip" :class="{ on: subject === 'all' }" @click="subject = 'all'">
                    全部<em>{{ stat.total }}</em>
                </span>
                <span
                    class="chip"
                    v-for="f in facets"
                    :key="f.key"
                    :class="{ on: subject === f.key }"
                    @click="subject = f.key"
                >
                    {{ f.name }}<em>{{ f.count }}</em>
                </span>
            </div>

            <!-- ---------- 工具条 ---------- -->
            <div class="toolbar">
                <span class="only" :class="{ on: onlyUnmastered }" @click="onlyUnmastered = !onlyUnmastered">
                    <i class="box"></i>只看未掌握
                </span>
                <span class="toolbar-count">共 {{ list.length }} 题</span>
            </div>

            <!-- ---------- 错题列表 ---------- -->
            <div class="q-list">
                <div class="q-card" v-for="q in list" :key="q.id" :class="{ mastered: q.mastered }">
                    <div class="q-head">
                        <span class="q-badge" :style="{ background: q.meta.bg, color: q.meta.fg }">
                            {{ q.meta.short }}
                        </span>
                        <span class="q-tag">{{ q.tag }}</span>
                        <span class="q-times" v-if="q.times > 1">错 {{ q.times }} 次</span>
                        <span class="q-ok" v-if="q.mastered">已掌握</span>
                    </div>

                    <p class="q-stem">{{ q.stem }}</p>

                    <div class="q-ans">
                        <div class="qa-item bad">
                            <span class="qa-label">我的答案</span>
                            <span class="qa-val">{{ q.mine }}</span>
                        </div>
                        <div class="qa-item good">
                            <span class="qa-label">正确答案</span>
                            <span class="qa-val">{{ q.right }}</span>
                        </div>
                    </div>

                    <p class="q-from">{{ q.from }} · {{ q.date }}</p>

                    <div class="q-an" v-if="openId === q.id">
                        <p class="q-an-title">解析</p>
                        <p class="q-an-text">{{ q.analysis }}</p>
                    </div>

                    <div class="q-foot">
                        <span class="q-more" @click="toggleOpen(q.id)">
                            {{ openId === q.id ? '收起解析 ⌃' : '看解析 ⌄' }}
                        </span>
                        <span class="q-mark" :class="{ on: q.mastered }" @click="toggleMastered(q)">
                            {{ q.mastered ? '取消已掌握' : '标记已掌握' }}
                        </span>
                    </div>
                </div>

                <p class="empty" v-if="!list.length">这个筛选下没有错题</p>
            </div>

            <p class="tip">演示数据 · 接入题库后按同样的结构返回即可</p>
        </main>

        <p class="toast-tip" v-if="toast">{{ toast }}</p>
    </div>
</template>

<script>
import { fetchWrongBook, wrongStats, wrongFacets, setWrongMastered } from '../../utils/studyData';

export default {
    name: 'AppWrongBook',
    data() {
        return {
            all: [],
            subject: 'all',
            onlyUnmastered: false,
            openId: '',
            toast: '',
            toastTimer: null
        };
    },
    computed: {
        /** 总览卡片始终按**全部**错题算，不随筛选变化 */
        stat() {
            return wrongStats(this.all);
        },
        /** 科目筛选条同理，固定用全部错题统计 */
        facets() {
            return wrongFacets(this.all);
        },
        list() {
            let arr = this.all;
            if (this.subject !== 'all') {
                arr = arr.filter(q => q.subject === this.subject);
            }
            if (this.onlyUnmastered) {
                arr = arr.filter(q => !q.mastered);
            }
            return arr;
        }
    },
    created() {
        this.load();
    },
    beforeDestroy() {
        if (this.toastTimer) {
            clearTimeout(this.toastTimer);
        }
    },
    methods: {
        load() {
            fetchWrongBook()
                .then(list => {
                    this.all = list || [];
                })
                .catch(() => {
                    this.all = [];
                });
        },
        toggleOpen(id) {
            this.openId = this.openId === id ? '' : id;
        },
        /** 先本地翻转让手感立刻跟上，再写回数据层（失败则回滚） */
        toggleMastered(q) {
            const next = !q.mastered;
            q.mastered = next;
            setWrongMastered(q.id, next).catch(() => {
                q.mastered = !next;
                this.showToast('操作失败，稍后再试');
            });
        },
        goBack() {
            if (window.history.length > 1) {
                this.$router.back();
                return;
            }
            this.$router.replace({ path: '/home' });
        },
        showToast(text) {
            this.toast = text;
            if (this.toastTimer) {
                clearTimeout(this.toastTimer);
            }
            this.toastTimer = setTimeout(() => {
                this.toast = '';
            }, 1800);
        }
    }
};
</script>

<style lang="less" scoped>
.wrong-page {
    min-height: 100vh;
    box-sizing: border-box;
    /* tabbar 100px + 安全区，再留一点呼吸 */
    padding-bottom: calc(170px + constant(safe-area-inset-bottom));
    padding-bottom: calc(170px + env(safe-area-inset-bottom));
    background: #f4f6fa;
}

/* ---------------- 头部 ---------------- */
.wp-hero {
    position: relative;
    padding: 40px 40px 60px;
    color: #fff;
    background: var(--blueTheme, #0066b3);
    border-radius: 0 0 44px 44px;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        top: -160px;
        right: -110px;
        width: 400px;
        height: 400px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.13);
    }
}

.hero-top {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.hero-back {
    width: 60px;
    font-size: 46px;
    line-height: 1;
    color: #fff;

    &.ghost {
        visibility: hidden;
    }
    &:active {
        opacity: 0.7;
    }
}

.hero-title {
    font-size: 34px;
    font-weight: 600;
    letter-spacing: 1px;
}

.hero-nums {
    position: relative;
    z-index: 1;
    display: flex;
    margin-top: 34px;
}

.hn {
    flex: 1;
    min-width: 0;
}

.hn-label {
    margin: 0;
    font-size: 22px;
    opacity: 0.84;
}

.hn-num {
    margin: 8px 0 0;
    font-size: 48px;
    font-weight: 600;
    line-height: 1.1;

    em {
        margin-left: 4px;
        font-style: normal;
        font-size: 22px;
        font-weight: 400;
        opacity: 0.84;
    }
    .warn {
        color: #ffd8a8;
    }
}

.hero-bar {
    position: relative;
    z-index: 1;
    height: 10px;
    margin: 24px 0 14px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.25);
    overflow: hidden;

    i {
        display: block;
        height: 100%;
        border-radius: 999px;
        background: #fff;
        transition: width 0.5s ease;
    }
}

.hero-tip {
    position: relative;
    z-index: 1;
    margin: 0;
    font-size: 22px;
    opacity: 0.82;
}

/* ---------------- 主体 ---------------- */
.wp-body {
    padding: 0 30px;
}

/* 科目筛选 */
.chips {
    display: flex;
    margin-top: 28px;
    overflow-x: auto;

    &::-webkit-scrollbar {
        display: none;
    }
}

.chip {
    flex: none;
    margin-right: 16px;
    padding: 12px 28px;
    border-radius: 999px;
    font-size: 24px;
    color: #5f6b7d;
    background: #fff;
    border: 1px solid #e8ecf2;

    em {
        margin-left: 8px;
        font-style: normal;
        font-size: 20px;
        color: #a3abba;
    }

    &.on {
        color: #fff;
        background: var(--blueTheme, #0066b3);
        border-color: var(--blueTheme, #0066b3);

        em {
            color: rgba(255, 255, 255, 0.8);
        }
    }
}

/* 工具条 */
.toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 26px 4px 18px;
}

.only {
    display: flex;
    align-items: center;
    font-size: 24px;
    color: #5f6b7d;

    .box {
        width: 30px;
        height: 30px;
        margin-right: 12px;
        border-radius: 9px;
        border: 1px solid #cbd3de;
        background: #fff;
        position: relative;
    }

    &.on {
        color: var(--blueTheme, #0066b3);

        .box {
            border-color: var(--blueTheme, #0066b3);
            background: var(--blueTheme, #0066b3);

            &::after {
                content: '';
                position: absolute;
                left: 10px;
                top: 4px;
                width: 8px;
                height: 15px;
                border: 2px solid #fff;
                border-top: 0;
                border-left: 0;
                transform: rotate(45deg);
            }
        }
    }
}

.toolbar-count {
    font-size: 22px;
    color: #98a1b0;
}

/* 错题卡 */
.q-card {
    margin-bottom: 22px;
    padding: 30px;
    background: #fff;
    border-radius: 26px;
    box-shadow: 0 8px 28px rgba(15, 39, 76, 0.06);

    &.mastered {
        .q-stem {
            color: #98a1b0;
        }
    }
}

.q-head {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.q-badge {
    flex: none;
    width: 48px;
    height: 48px;
    margin-right: 16px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    font-weight: 600;
}

.q-tag {
    padding: 6px 18px;
    border-radius: 999px;
    font-size: 22px;
    color: #5f6b7d;
    background: #f4f6fa;
}

.q-times {
    margin-left: 12px;
    padding: 6px 18px;
    border-radius: 999px;
    font-size: 20px;
    color: #a32d2d;
    background: #fcebeb;
}

.q-ok {
    margin-left: 12px;
    padding: 6px 18px;
    border-radius: 999px;
    font-size: 20px;
    color: #0f6e56;
    background: #e1f5ee;
}

.q-stem {
    margin: 24px 0 0;
    font-size: 28px;
    line-height: 1.6;
    color: #2b3445;
}

.q-ans {
    display: flex;
    margin-top: 22px;
}

.qa-item {
    flex: 1;
    min-width: 0;
    padding: 18px 22px;
    border-radius: 18px;

    & + .qa-item {
        margin-left: 18px;
    }

    &.bad {
        background: #fcebeb;

        .qa-val {
            color: #a32d2d;
        }
    }
    &.good {
        background: #e1f5ee;

        .qa-val {
            color: #0f6e56;
        }
    }
}

.qa-label {
    display: block;
    font-size: 20px;
    color: #8a94a6;
}

.qa-val {
    display: block;
    margin-top: 8px;
    font-size: 30px;
    font-weight: 600;
    word-break: break-all;
}

.q-from {
    margin: 20px 0 0;
    font-size: 22px;
    color: #a3abba;
}

.q-an {
    margin-top: 22px;
    padding: 22px 24px;
    border-radius: 18px;
    background: #f7f9fc;
}

.q-an-title {
    margin: 0;
    font-size: 22px;
    font-weight: 600;
    color: #5f6b7d;
}

.q-an-text {
    margin: 12px 0 0;
    font-size: 24px;
    line-height: 1.7;
    color: #4a5566;
}

.q-foot {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 24px;
    padding-top: 22px;
    border-top: 1px solid #f2f4f8;
}

.q-more {
    font-size: 24px;
    color: #98a1b0;

    &:active {
        opacity: 0.7;
    }
}

.q-mark {
    padding: 12px 30px;
    border-radius: 999px;
    font-size: 22px;
    color: var(--blueTheme, #0066b3);
    background: var(--lightBlueTheme, #d4eafa);

    &.on {
        color: #5f6b7d;
        background: #f4f6fa;
    }
    &:active {
        opacity: 0.8;
    }
}

.empty {
    padding: 80px 0;
    text-align: center;
    font-size: 24px;
    color: #a3abba;
}

.tip {
    margin: 30px 0 0;
    text-align: center;
    font-size: 20px;
    color: #c2c9d6;
}

.toast-tip {
    position: fixed;
    left: 50%;
    bottom: calc(240px + constant(safe-area-inset-bottom));
    bottom: calc(240px + env(safe-area-inset-bottom));
    z-index: 600;
    transform: translateX(-50%);
    padding: 20px 36px;
    border-radius: 999px;
    font-size: 24px;
    color: #fff;
    background: rgba(17, 24, 39, 0.86);
    white-space: nowrap;
}
</style>
